<template>
  <basic-container>
    <div class="flex flex-justify-between">
      <search-form
        :form-items="searchFormItems"
        :initial-values="initVals"
        @search="handleSearch"
        @reset="handleReset"
        @add="handleAdd"
        :hasAdd="true"
      >
        <!-- 自定义表单项插槽 -->
        <template #channelSelect="{ formData }">
          <YdChannelSelect
            v-model="formData.name"
            placeholder="请选择渠道名称"
            :params="{}"
            :multiple="true"
            :collapseTags="true"
            :collapseTagsLimit="1"
            :maxSelections="5"
          />
        </template>

        <!-- 自定义按钮插槽 -->
        <template #buttons>
          <!-- 自定义按钮内容 -->
        </template>
      </search-form>

      <div class="btnGroup">
        <el-button
          class="add"
          type="primary"
          @click="configOpen"
          icon="el-icon-takeaway-box"
          style="margin-right: 40px"
          size="mini"
          v-has-permi="['channel_confspec_btn']"
        >
          相关说明配置
        </el-button>
        <el-button
          class="add"
          type="primary"
          @click="operateLog"
          icon="el-icon-takeaway-box"
          style="margin-right: 40px"
          size="mini"
        >
          操作日志
        </el-button>
        <el-button
          class="add"
          type="primary"
          @click="exportClick"
          icon="el-icon-takeaway-box"
          style="margin-right: 40px"
          size="mini"
        >
          导出
        </el-button>
      </div>
    </div>
    <div class="page-table-coantainer">
      <el-table
        :data="resData"
        style="width: 100%"
        v-loading="loading"
        :border="true"
        max-height="650"
        size="mini"
        :header-cell-style="{ background: '#f5f7fa' }"
        :span-method="objectSpanMethod"
        :cell-style="tableCellStyle"
      >
        <el-table-column
          v-for="(item, index) in cols"
          :fixed="item.prop === 'id' || item.prop === 'name' ? true : false"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.width"
          align="center"
        >
          <template slot-scope="scope">
            <!-- 渠道链接列 -->
            <template v-if="item.prop === 'shortUrl'">
              <div v-if="scope.row.shortUrl">
                <a :href="scope.row.shortUrl" style="color: #0a85f8" target="_blank">
                  {{ scope.row.shortUrl }}
                </a>
                <i
                  class="el-icon-download copy-icon"
                  @click="downLoadUrl(scope.row)"
                  style="margin-left: 5px; cursor: pointer"
                ></i>
                <i
                  class="el-icon-document-copy copy-icon"
                  @click="copyUrl(scope.row.shortUrl)"
                  style="margin-left: 5px; cursor: pointer"
                ></i>
              </div>
              <div v-else>-</div>
            </template>

            <!--            渠道名称-->
            <template v-else-if="item.prop === 'name'">
              <div>
                <el-popover placement="bottom" width="250" trigger="hover">
                  <div class="infoList">
                    <div class="title">{{ scope.row.name }}</div>
                    <div class="info" v-for="info in scope.row.infoList" :key="info.label">
                      <span class="label">{{ info.label }}:</span>
                      <span>{{ info.value || '-' }}</span>
                    </div>
                  </div>
                  <span slot="reference">
                    {{
                      scope.row.name.length > 10
                        ? `${scope.row.name.slice(0, 10)}...`
                        : scope.row.name
                    }}
                  </span>
                </el-popover>
                <div>
                  <!-- //1：待生效 2：生效中 3：已失效 -->
                  <el-button
                    size="mini"
                    round
                    :type="
                      scope.row.status === 1
                        ? 'warning'
                        : scope.row.status === 2
                        ? 'success'
                        : 'info'
                    "
                  >
                    {{
                      scope.row.status === 1
                        ? '待生效'
                        : scope.row.status === 2
                        ? '生效中'
                        : '已失效'
                    }}
                  </el-button>
                </div>
              </div>
            </template>

            <!-- 操作列 -->
            <template v-else-if="item.prop === 'operation'">
              <el-button
                v-if="!scope.row.isEmptyLinks"
                type="text"
                class="delete-btn"
                @click="handleDeleteLink(scope.row)"
              >
                删除
              </el-button>
            </template>

            <!-- 管理渠道列 -->
            <template v-else-if="item.prop === 'manage'">
              <div class="operation-btns">
                <el-button
                  v-if="scope.row.isFirstLink || scope.row.isEmptyLinks"
                  type="text"
                  class="edit-btn"
                  @click="handleEdit(scope.row)"
                  style="margin-right: 10px"
                >
                  编辑
                </el-button>
                <el-button
                  v-if="scope.row.isFirstLink || scope.row.isEmptyLinks"
                  type="text"
                  class="delete-btn"
                  @click="handleDeleteChannel(scope.row)"
                >
                  删除
                </el-button>

                <el-button
                  type="text"
                  style="color: #409eff"
                  @click="commissionOpen(scope.row)"
                  v-has-permi="['channel_view_commission_details']"
                >
                  查看佣金明细
                </el-button>
              </div>
            </template>

            <!-- 默认列内容 -->
            <template v-else>
              <span
                v-if="scope.row[item.prop] !== undefined && scope.row[item.prop] !== ''"
                class="11111"
              >
                {{ item.formatter ? item.formatter(scope.row) : scope.row[item.prop] }}
              </span>
              <span v-else>-</span>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="fetchData"
        :current-page.sync="page.page"
        :page-sizes="page.pageSizes"
        :page-size.sync="page.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
      />
    </div>
    <CustomDialog :show.sync="dialog.show" v-bind="dialog" @submit="dialog.onSubmit">
      <component
        v-if="dialog.show"
        :is="dialog.tag"
        v-bind="dialog"
        :loading="dialog.loading"
        ref="panel"
        title=""
      />
    </CustomDialog>
    <LogModel
      :visible="visible"
      :active="'channelCode'"
      :extendHeads="extendHeads"
      :needFormat="true"
      :formatParams="formatParams"
      :needFormatResult="true"
      :formatResult="formatResult"
      :customRequest="true"
      :request="getLogList"
      @close="handleClose"
      :operateTypeList="operateTypeList"
    />
    <qr-load v-model="qrVisible" :qrCodeData="qrCodeData" />

    <Commission
      v-if="commission.show"
      :show="commission.show"
      :data="commission.data"
      @close="commissionClose"
    />
    <ConfigDialog v-if="config.show" :show="config.show" :data="config.data" @close="configClose" />
  </basic-container>
</template>

<script>
  import { Message, MessageBox } from 'element-ui'
  import {
    getChannelCodeList,
    addChannel,
    deleteChannel,
    addClient,
    getLogList,
    getChannelManageInstructionInfo
  } from '@/api'
  import SearchForm from '@/components/SearchForm'
  import CustomDialog from '@/components/commonDialog'
  import LogModel from '@/components/operateLog/oLog.vue'
  import editChannelCode from './components/EditChannelCode.vue'
  import qrLoad from './components/QrLoad.vue'
  import { getClientMap, getOperateType, getOperatorList, getStatusMap } from './hooks/config'
  import { exportMergeableExcel } from '../../util'
  import Commission from './components/commission.vue'
  import ConfigDialog from './components/configDialog.vue'

  export default {
    name: 'ChannelCodeList',
    components: {
      SearchForm,
      CustomDialog,
      LogModel,
      editChannelCode,
      qrLoad,
      Commission,
      ConfigDialog
    },
    provide() {
      return {
        flag: 1 // 1渠道商  2合伙人
      }
    },
    data() {
      return {
        config: {
          show: false,
          data: ''
        },
        commission: {
          show: false,
          data: {}
        },
        visible: false,
        qrVisible: false,
        qrCodeUrl: '',
        // 用于初始化
        initVals: {
          date: [],
          name: [], // 修改为数组，支持多选
          client: ''
        },
        // 查询参数存储
        query: {
          type: 1, // 1渠道商 2合伙人
          date: [],
          name: [], // 修改为数组，支持多选
          client: ''
        },
        loading: false,
        resData: [],
        localRequestData: {},
        extendHeads: [
          {
            label: '操作内容',
            prop: 'text',
            align: 'left'
          }
        ],
        operateTypeList: getOperateType({}, true),
        // 搜索表单配置
        searchFormItems: [
          {
            type: 'daterange',
            label: '时间',
            prop: 'date',
            valueFormat: 'yyyy-MM-dd'
          },
          {
            type: 'custom',
            label: '渠道名称',
            prop: 'name',
            slot: 'channelSelect'
          },
          {
            type: 'select',
            label: '应用端',
            prop: 'client',
            placeholder: '请选择应用端',
            clearable: true,
            options: getClientMap({}, true)
          },
          {
            type: 'select',
            label: '渠道码状态',
            prop: 'status',
            clearable: true,
            options: getStatusMap({}, true)
          }
        ],
        // 表头配置
        cols: [
          {
            label: '渠道ID',
            prop: 'id',
            width: '80'
          },
          {
            label: '渠道名称',
            prop: 'name',
            width: '150'
          },
          {
            label: '渠道链接',
            prop: 'shortUrl',
            width: '200'
          },
          {
            label: '应用端',
            prop: 'client',
            width: '120',
            formatter: (row) => {
              return getClientMap(row)
            }
          },
          {
            label: '名称',
            prop: 'appName',
            width: '140'
          },
          {
            label: '扫码次数（PV）',
            prop: 'pv',
            width: '120'
          },
          {
            label: '扫码次数（UV）',
            prop: 'uv',
            width: '120'
          },
          {
            label: '注册用户数',
            prop: 'registerUserNum',
            width: '120'
          },
          /* {
            label: '支付用户数',
            prop: 'payUserNum',
            width: '120'
          }, */
          {
            label: '渠道注册支付用户数',
            prop: 'channelPayUserNum',
            width: '120'
          },
          {
            label: '非渠道注册支付用户数',
            prop: 'notChannelPayUserNum',
            width: '120'
          },
          {
            label: '首单订单金额',
            prop: 'firstOrderAmount',
            width: '120'
          },
          {
            label: '首单订单佣金金额',
            prop: 'firstOrderCommissionAmount',
            width: '120'
          },
          {
            label: '复购订单金额',
            prop: 'commonOrderAmount',
            width: '120'
          },
          {
            label: '复购订单佣金金额',
            prop: 'commonOrderCommissionAmount',
            width: '120'
          },
          {
            label: '渠道完单数',
            prop: 'orderCount',
            width: '120'
          },
          {
            label: '渠道订单金额',
            prop: 'totalMoney',
            width: '120',
            formatter: ({ totalMoney }) => {
              // 将分转换为元，并添加两位小数和千分位分隔符
              if (totalMoney === undefined || totalMoney === null || totalMoney === '') return '-'
              // 分转元
              const yuan = parseFloat(totalMoney) / 100
              // 格式化为带两位小数的字符串
              return yuan.toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })
            }
          },
          {
            label: '更新人',
            prop: 'userName',
            width: '200'
          },
          {
            label: '创建时间',
            prop: 'createTime',
            width: '160'
          },
          {
            label: '操作',
            prop: 'operation',
            width: '80'
          },
          {
            label: '管理渠道',
            prop: 'manage',
            width: '120'
          }
        ],
        // 分页数据
        page: {
          page: 1,
          pageSizes: [10, 20, 30, 50, 100],
          size: 10,
          total: 0
        },
        dialog: {
          show: false,
          tag: 'editChannelCode',
          loading: false,
          onSubmit: () => {}
        },
        qrCodeData: null
      }
    },
    created() {
      this.fetchData()
    },
    methods: {
      configClose(v) {
        this.config.show = false
      },
      async configOpen() {
        const data = {
          type: 1
        }
        const res = await getChannelManageInstructionInfo(data)
        if (res.code === 0) {
          this.config.show = true
          this.config.data = res.data.content
        }
      },

      commissionClose() {
        this.commission.show = false
      },
      async commissionOpen(row) {
        this.commission.show = true
        this.commission.data = {
          channelId: row.id
        }
        // const data = {
        // 	channelId:row.id
        // }
        // const res =await postChannelManageDetail(data)
      },

      getLogList,
      // 将嵌套数据转换为表格扁平数据格式
      transformDataForTable(data) {
        if (!data || !Array.isArray(data)) {
          console.error('传入的数据格式不正确:', data)
          return []
        }

        const result = []

        data.forEach((channel) => {
          if (
            !channel.channelClientVoList ||
            !Array.isArray(channel.channelClientVoList) ||
            channel.channelClientVoList.length === 0
          ) {
            // 没有链接的渠道也需要显示一行
            result.push({
              status: channel.status,
              id: channel.id,
              name: channel.name,
              infoList: [
                { label: '地址', value: channel.address },
                { label: '负责人', value: channel.admin },
                { label: '邮箱', value: channel.email },
                { label: '电话', value: channel.phone },
                { label: '备注', value: channel.remark },
                { label: '首笔订单', value: `${channel.fristOrder / 100}%` },
                { label: '复购订单', value: `${channel.commondOrder / 100}%` }
              ],
              shortUrl: '',
              client: '',
              appName: '',
              pv: '',
              uv: '',
              registerUserNum: '',
              payUserNum: '',
              channelPayUserNum: '',
              notChannelPayUserNum: '',
              firstOrderAmount: '',
              firstOrderCommissionAmount: '',
              commonOrderAmount: '',
              commonOrderCommissionAmount: '',
              orderCount: '',
              totalMoney: '',
              userName: '',
              createTime: '',
              updateTime: '',
              // 特殊标记用于合并单元格
              isEmptyLinks: true
            })
          } else {
            // 有链接的渠道，展开每个链接为一行
            channel.channelClientVoList.forEach((link, index) => {
              result.push({
                status: channel.status,
                id: channel.id,
                name: channel.name,
                infoList: [
                  { label: '地址', value: channel.address },
                  { label: '负责人', value: channel.admin },
                  { label: '邮箱', value: channel.email },
                  { label: '电话', value: channel.phone },
                  { label: '备注', value: channel.remark },
                  { label: '首笔订单', value: `${channel.fristOrder / 100}%` },
                  { label: '复购订单', value: `${channel.commondOrder / 100}%` }
                ],
                shortUrl: link.shortUrl,
                client: link.client,
                appName: link.name,
                clientId: link.id,
                pv: link.pv,
                uv: link.uv,
                registerUserNum: link.registerUserNum,
                payUserNum: link.payUserNum,
                totalMoney: link.totalMoney,
                // 标记是否是该渠道的第一个链接，用于表格合并单元格
                isFirstLink: index === 0,
                // 记录该渠道有多少个链接，用于表格合并单元格

                linkCount: channel.channelClientVoList.length,
                channelPayUserNum: link.channelPayUserNum,
                notChannelPayUserNum: link.notChannelPayUserNum,
                firstOrderAmount: link.firstOrderAmount / 100,
                firstOrderCommissionAmount: link.firstOrderCommissionAmount / 100,
                commonOrderAmount: link.commonOrderAmount / 100,
                commonOrderCommissionAmount: link.commonOrderCommissionAmount / 100,
                orderCount: link.orderCount,
                userName: (link.userName || '') + ' ' + (link.updateTime || ''),
                createTime: link.createTime
              })
            })
          }
        })
        return result
      },
      fetchData() {
        this.loading = true
        // 从API获取渠道码列表数据
        const params = this.getParams()
        getChannelCodeList({
          ...this.page,
          ...params
        })
          .then((res) => {
            if (res.code === 0 && res.data && res.data.records) {
              // 将嵌套数据结构转换为表格需要的扁平结构
              this.resData = this.transformDataForTable(res.data.records)
              this.localRequestData = JSON.parse(JSON.stringify(res.data.records))
              // 更新分页信息
              Object.assign(this.page, {
                page: res.data.current || 1,
                total: res.data.total || 0,
                size: res.data.size || 10
              })
            } else {
              this.resData = []
              // Message.error('获取数据失败：' + (res.msg || '未知错误'))
            }
            this.loading = false
          })
          .catch((error) => {
            console.error('获取渠道码列表失败', error)
            this.resData = []
            // Message.error('获取数据失败：' + (error.message || '服务异常'))
          })
          .finally(() => {
            this.loading = false
          })
      },
      // 获取请求数据
      getParams() {
        const { date, name, ...rest } = this.query
        const [start, end] = date || []
        return {
          endDate: end,
          startDate: start,
          name: name.map((item) => item.name),
          ...rest
        }
      },
      operateLog() {
        this.visible = true
      },
      async exportClick() {
        MessageBox.confirm('导出渠道码需要较长时间，请耐心等待', '确定导出吗？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            // 定义表头
            const headers = {
              id: '渠道ID',
              name: '渠道名称',
              shortUrl: '渠道链接',
              client: '应用端',
              appName: '名称',
              pv: '扫码次数（PV）',
              uv: '扫码次数（UV）',
              registerUserNum: '注册用户数',
              payUserNum: '支付用户数',
              channelPayUserNum: '渠道注册支付用户数',
              notChannelPayUserNum: '非渠道注册支付用户数',
              firstOrderAmount: '首单订单金额',
              firstOrderCommissionAmount: '首单订单佣金金额',
              commonOrderAmount: '复购订单金额',
              commonOrderCommissionAmount: '复购订单佣金金额',
              orderCount: '渠道完单数',
              totalMoney: '渠道订单金额',
              userName: '更新人',
              createTime: '创建时间'
            }

            // 排除的列
            const excludeColumns = [
              'operation',
              'manage',
              'isFirstLink',
              'isEmptyLinks',
              'linkCount',
              'clientId'
            ]

            // 导出选项
            const exportOptions = {
              needMerge: true,
              // 可以手动指定需要合并的列
              mergeColumns: ['id', 'name'],
              // 也可以启用自动检测 (设置为true时会覆盖mergeColumns设置)
              // autoDetectMerge: true,
              fileName: `渠道码列表_${new Date().toISOString().split('T')[0]}.xlsx`,
              dataTransformer: (records) => {
                // 转换数据为扁平结构，与transformDataForTable函数逻辑类似
                return this.transformDataForTable(records)
              },
              // 添加字段格式化器
              formatters: {
                // 应用端转换为文本说明
                client: (value) => {
                  // 直接传递对象可能导致问题，改为直接使用value
                  // 检查映射函数是否存在
                  if (typeof getClientMap === 'function') {
                    const result = getClientMap({ client: value })
                    return result || `-${value}-`
                  }
                  // 如果映射函数不存在或映射失败，返回原值
                  return value !== undefined && value !== null ? value : '-'
                },
                // 处理数值型数据，确保为数字或显示为0
                pv: (value) => {
                  return value !== undefined && value !== null ? Number(value) : '-'
                },
                uv: (value) => {
                  return value !== undefined && value !== null ? Number(value) : '-'
                },
                registerUserNum: (value) => {
                  return value !== undefined && value !== null ? Number(value) : '-'
                },
                payUserNum: (value) => {
                  return value !== undefined && value !== null ? Number(value) : '-'
                },
                totalMoney: (value) => {
                  // 将分转换为元，并添加两位小数和千分位分隔符
                  if (value === undefined || value === null || value === '') return '-'
                  // 分转元
                  const yuan = parseFloat(value) / 100
                  // 格式化为带两位小数的字符串
                  return yuan.toLocaleString('zh-CN', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })
                },
                // 格式化日期，确保日期格式正确
                createTime: (value) => {
                  if (!value) return '-'
                  // 简单日期格式检查，如果需要可以添加更复杂的格式化
                  return String(value)
                },
                // 处理空链接
                shortUrl: (value) => {
                  return value || '-'
                }
              }
            }

            // 调用新的导出函数
            exportMergeableExcel(
              getChannelCodeList,
              this.getParams(), // 使用当前的查询参数
              headers,
              excludeColumns,
              exportOptions
            )
          })
          .catch(() => {})
      },
      // 单元格合并方法
      objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        // 如果表格数据为空，不执行合并
        if (!this.resData || this.resData.length === 0) {
          return { rowspan: 1, colspan: 1 }
        }

        // 对渠道ID和渠道名称列进行合并
        if (columnIndex === 0 || columnIndex === 1) {
          if (rowIndex === 0) {
            // 找出id相同的行数
            const sameIdRowCount = this.resData.filter((item) => item && item.id === row.id).length

            return { rowspan: sameIdRowCount, colspan: 1 }
          } else {
            const prevRow = this.resData[rowIndex - 1]
            const currentRow = row

            if (!prevRow || !currentRow || !prevRow.id || !currentRow.id) {
              return { rowspan: 1, colspan: 1 }
            }

            if (currentRow.id === prevRow.id) {
              // 这行是关键 - 当ID与前一行相同时，不显示单元格
              return { rowspan: 0, colspan: 0 }
            } else {
              // 找出相同ID的行数，用于合并
              const sameIdCount = this.resData.filter(
                (item, idx) => item && item.id === currentRow.id && idx >= rowIndex
              ).length

              return { rowspan: sameIdCount, colspan: 1 }
            }
          }
        }

        // 管理渠道列只在每个渠道的第一行或空链接行显示
        if (columnIndex === this.cols.length - 1) {
          if (row.isFirstLink || row.isEmptyLinks) {
            // 找出同一渠道的行数
            const sameIdCount = this.resData.filter((item) => item && item.id === row.id).length

            return { rowspan: sameIdCount, colspan: 1 }
          } else {
            return { rowspan: 0, colspan: 0 }
          }
        }

        return { rowspan: 1, colspan: 1 }
      },
      tableCellStyle({ row, column, rowIndex, columnIndex }) {
        const style = {}

        // 为ID和名称列添加背景色
        if (columnIndex === 0 || columnIndex === 1) {
          style.background = '#f5f7fa'
        }

        return style
      },
      // 搜索
      handleSearch(formData) {
        Object.assign(this.query, { ...formData })
        Object.assign(this.page, {
          page: 1
        })
        this.fetchData()
      },
      // 重置
      handleReset(form) {
        Object.assign(this.page, {
          page: 1,
          size: 10
        })
        Object.assign(this.query, {
          ...form
        })
        this.fetchData()
      },
      // 新增
      handleAdd() {
        Object.assign(this.dialog, {
          title: '新增渠道码（渠道商）',
          show: true,
          tag: editChannelCode,
          cancelText: '取消',
          submitText: '保存',
          width: '1000px',
          loading: false,
          editData: {},
          onSubmit: () => {
            this.$refs.panel.validate().then((form) => {
              form.channelInfo.startTime = form.channelInfo.dateRange[0]
              form.channelInfo.endTime = form.channelInfo.dateRange[1]
              // form.channelInfo.type = 1
              this.editOrAddCallback(form)
            })
          },
          beforeClose: (done) => {
            this.$refs.panel.confirmBeforeClose().then((value) => {
              if (value) {
                done && done()
                this.dialog.show = false
              }
            })
          }
        })
      },
      // 分页大小改变
      handleSizeChange(size) {
        Object.assign(this.page, {
          page: 1
        })
        this.fetchData()
      },
      /**
       * 关闭日志弹窗
       */
      handleClose() {
        this.visible = false
      },
      // 复制链接
      copyUrl(url) {
        if (navigator.clipboard) {
          navigator.clipboard
            .writeText(url)
            .then(() => {
              Message({
                message: '链接已复制到剪贴板',
                type: 'success'
              })
            })
            .catch(() => {
              Message({
                message: '复制失败，请手动复制',
                type: 'error'
              })
            })
        } else {
          // 兼容不支持clipboard API的浏览器
          const textarea = document.createElement('textarea')
          textarea.value = url
          document.body.appendChild(textarea)
          textarea.select()
          try {
            document.execCommand('copy')
            Message({
              message: '链接已复制到剪贴板',
              type: 'success'
            })
          } catch (err) {
            Message({
              message: '复制失败，请手动复制',
              type: 'error'
            })
          }
          document.body.removeChild(textarea)
        }
      },
      // 下载链接
      downLoadUrl(row) {
        this.qrVisible = true
        // this.qrCodeUrl = row.shortUrl
        this.qrCodeData = row
      },
      // 删除链接
      handleDeleteLink(row) {
        const { id, clientId } = row
        MessageBox.confirm('删除后，用户无法通过该渠道访问，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const link =
            this.localRequestData.find((item) => {
              return item.id === id
            }) || {}
          const arr = link.channelClientVoList.map((link) => {
            link.isDelete = link.id === clientId ? 1 : 0
            return link
          })
          addClient({
            channelId: id,
            clientList: arr
          }).then((res) => {
            this.fetchData()
          })
        })
      },
      // 编辑渠道
      handleEdit(row) {
        const editData = this.formatEditData(row)
        Object.assign(this.dialog, {
          title: '编辑渠道码（渠道商）',
          show: true,
          tag: editChannelCode,
          cancelText: '取消',
          submitText: '保存',
          width: '1000px',
          // 传递当前行数据到编辑组件
          editData,
          onSubmit: () => {
            this.$refs.panel.validate().then((form) => {
              this.editOrAddCallback(form)
            })
          },
          beforeClose: (done) => {
            this.$refs.panel.confirmBeforeClose().then((value) => {
              if (value) {
                done && done()
                this.dialog.show = false
              }
            })
          }
        })
      },
      /**
       * 处理新增编辑后操作
       */
      editOrAddCallback(data) {
        this.dialog.loading = true
        const { channelInfo, applications } = data
        const { channelClientVoList = [] } =
          this.localRequestData.find((item) => item.id === channelInfo.id) || {}
        addChannel({
          ...channelInfo,
          fristOrder: channelInfo.fristOrder
            ? channelInfo.fristOrder * 100
            : channelInfo.fristOrder,
          commondOrder: channelInfo.commondOrder
            ? channelInfo.commondOrder * 100
            : channelInfo.commondOrder
        })
          .then((res) => {
            if (res.code === 0) {
              let clientList = []
              const map = new Map([
                ['wechat', 1],
                ['alipay', 2],
                ['douyin', 3],
                ['app', 4]
              ])
              for (const applicationsKey in applications) {
                if (applications[applicationsKey].length > 0) {
                  applications[applicationsKey].forEach((applient) => {
                    clientList.push({
                      client: map.get(applicationsKey),
                      ...applient
                    })
                  })
                }
              }
              // 处理数据，将删除的数据设置标识字段并传给后端
              if (channelInfo.id && channelClientVoList) {
                channelClientVoList.forEach((client) => {
                  if (clientList.findIndex((client1) => client1.id === client.id) === -1) {
                    clientList.push({
                      isDelete: 1,
                      ...client
                    })
                  }
                })
                clientList = clientList.map((client) => {
                  if (client.id) {
                    return {
                      isDelete: client.isDelete === 1 ? 1 : 0,
                      ...client
                    }
                  }
                  return { ...client }
                })
              }
              if (clientList.length > 0) {
                addClient({
                  channelId: res.data,
                  clientList
                })
                  .then((res) => {
                    this.dialog.show = false
                    this.fetchData()
                  })
                  .finally(() => {
                    this.dialog.loading = false
                  })
              } else {
                this.dialog.show = false
                this.dialog.loading = false
                this.fetchData()
              }
            } else {
              this.dialog.loading = false
            }
          })
          .catch(() => {
            this.dialog.loading = false
          })
      },
      /**
       * 格式化编辑数据
       */
      formatEditData(row) {
        const { id } = row
        const localData = this.localRequestData.find((item) => item.id === id) || {}
        const { channelClientVoList = [] } = localData
        const data = {
          channelInfo: {
            validityHours: localData.validityHours,
            dateRange: [localData.startTime, localData.endTime],
            startTime: localData.startTime,
            endTime: localData.endTime,
            id: localData.id,
            name: localData.name,
            address: localData.address,
            email: localData.email,
            phone: localData.phone,
            fristOrder: localData.fristOrder ? localData.fristOrder / 100 : localData.fristOrder,
            admin: localData.admin,
            remark: localData.remark,
            commondOrder: localData.commondOrder
              ? localData.commondOrder / 100
              : localData.commondOrder,
            type: localData.type
          },
          applications: {
            wechat: [],
            alipay: [],
            douyin: [],
            app: []
          }
        }
        if (channelClientVoList) {
          for (let i = 0; i < channelClientVoList.length; i++) {
            const item = channelClientVoList[i]
            const map = new Map([
              [1, 'wechat'], // 微信小程序
              [2, 'alipay'], // 支付宝地址
              [3, 'douyin'], // 抖音小程序
              [4, 'app'] // 乘客端app
            ])
            data.applications[map.get(item.client)].push({
              ...item,
              name: item.name,
              id: item.id
            })
          }
        }
        return data
      },
      // 删除渠道
      handleDeleteChannel(row) {
        const { id } = row
        MessageBox.confirm('删除后，所有渠道码无法正常访问，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteChannel(id).then((res) => {
            if (res.code === 0) {
              // 如果删除的是最后一个渠道并且最后一页数据的id全部相同(因为合并了单元格)，则页码需要减一
              if (this.resData.length === 1 && this.resData.every((item) => item.id === id)) {
                Object.assign(this.page, {
                  page: this.page.page - 1
                })
              }
              this.fetchData()
            }
          })
        })
      },
      formatParams(params) {
        const { current, size, userList, unionUserId, operateType, ...rest } = params
        const user = userList.find((user) => user.value === unionUserId) || {}
        return {
          channelType: 1,
          pageNo: current,
          pageSize: size,
          userName: user.label || '',
          types: operateType ? operateType.map((item) => Number(item)) : [],
          ...rest
        }
      },
      formatResult(list) {
        return list.map((item) => {
          const { userName, operator, type, createTime, text, ...rest } = item
          return {
            operator: getOperatorList({ operator }),
            operatorName: userName,
            operateTypeMsg: getOperateType({ type }),
            recordTime: createTime,
            textList: text ? text.split('\n') : '',
            ...rest
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .header::before {
    content: '';
    position: absolute;
    width: 1px;
    background-color: #ebeef5;
    display: block;
  }

  .header::before {
    height: 150px; //根据情况调整
    bottom: 0;
    right: 0; //根据情况调整
    transform: rotate(-77deg); //根据情况调整
    transform-origin: bottom;
  }

  ::v-deep .el-table_1_column_1 {
    padding: 0;

    ::v-deep .cell {
      padding: 0;
    }
  }

  .btnGroup {
    white-space: nowrap;
  }

  .pagination-box {
    margin: 10px 0;
    display: flex;
    justify-content: flex-end;
  }
  .infoList {
    .title {
      font-weight: bold;
    }
    .info {
      .label {
        font-weight: bold;
        margin-right: 5px;
      }
    }
  }
</style>
